import { Grid, Card, CardContent, Typography, Box } from "@mui/material";
import WarningIcon from '@mui/icons-material/Warning';

export const ConflictingVillageRulesVersion : React.FC = () => {

    return(

        <Grid 
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
        >
            
            <Card>
                <CardContent>
                    <Box display="flex" justifyContent="center">
                        <WarningIcon sx={{ color: "red", fontSize: 60 }}/>
                    </Box>
                      <Typography sx={{ marginTop: '20px'}}>
                        Cannot upload new Village Rules because there is already another version which starts today
                    </Typography>
                </CardContent>
            </Card>

        </Grid>

    );

};